<div class="d-flex justify-content-center align-items-center w-100 h-100 forgot-password-container">
  <div class="col-xl-4 col-md-6 col-10">
    <div class="card border-0 box-shadow rounded-0">
      <div class="card-header d-flex justify-content-center logo-bg align-items-center border-0 box-shadow">
        <img alt="Aladdin" class="logo" src="assets/img/app/aladdin-icon-blue.png">
      </div>

      <div class="card-body text-center pb-1">
        <div *ngIf="!emailSent; else emailSentMessage">
          <app-request-password-reset
            *ngIf="!resetToken"
            [email]="emailAddress"
            (emailSent)="onEmailSent($event)"
          ></app-request-password-reset>

          <app-reset-password
            *ngIf="resetToken"
            [resetToken]="resetToken"
            [email]="emailAddress"
            [isResendEnabled]="enableEmailSend"
            (emailSent)="onEmailSent($event)"
            (updateSuccess)="onUpdateSuccess()"
          ></app-reset-password>
        </div>

        <ng-template #emailSentMessage>
          <app-reset-email-sent
            [email]="emailAddress"
            [isResendEnabled]="enableEmailSend"
            (emailSent)="onEmailSent($event)"
          ></app-reset-email-sent>
        </ng-template>

        <div class="error-message" role="alert" *ngIf="errorMessage">
          <div class="d-flex flex-nowrap">
              <span class="fa fa-exclamation-triangle align-self-center mx-2"></span>
              <span class="mx-1">{{errorMessage}}</span>
              <span class="fa fa-exclamation-triangle align-self-center mx-2"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/auth/forgot-password/forgot-password.component.html